import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosSolicitacao from "../../servicos/servicos-solicitacao";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { useContext } from "react";
import Cancel from "../../img/svgs/Cancel";
import Delete from "../../img/svgs/Delete";
import Salvar from "../../img/svgs/Salvar";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import Edit from "../../img/svgs/Edit";


const ListSolicitacoesPendentes = () => {
  const { user } = useContext(AuthContext);
  const autorizado = user.role === 'root' || user.role === 'admin';
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [editado, setEditado] = useState(false)
  const [deletado, setDeletado] = useState(false)
  const [show, setShow] = useState(false);
  const [showObservacao, setShowObservacao] = useState(false);
  const containerRef = useRef(null);
  const observacao = useRef();
  const [solicitacao, setSolicitacao] = useState();
  const [entregue, setEntregue] = useState(false);
  const motivo_cancelamento = useRef();
  const [motivoVazio, setMotivoVazio] = useState(false);
  const [itemsSelecionados, setItemsSelecionados] = useState([]);
  const handleClose = () => setShow(false);
  const handleCloseObservacao = () => setShowObservacao(false);


  useEffect(() => {
    function getDados() {
      servicosSolicitacao.listarSolicitacoesPendentes()
        .then(response => {
          if (response.status === 200) {
            setSolicitacoes(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [entregue, editado, deletado]);


  const cancelarSolicitacao = (motivo) => {
    if (motivo === "") {
      setMotivoVazio(true);
    } else {
      setEditado(false);
      const data = {
        "status": "cancelado",
        "responsavel": user.nome,
        "observacao": motivo
      }
      servicosSolicitacao.cancelarSolicitacao(solicitacao.id_solicitacao, data).then(response => {
        if (response.status === 200) {
          setEditado(true);
        }
      })
      handleClose();
    }
  }

  const editarSolicitacao = () => {
    setEditado(false);
    const data = {
      "responsavel": user.nome,
      "observacao": observacao.current.value
    }
    servicosSolicitacao.editar(solicitacao.id_solicitacao, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Observação adicionada");
      }
    }).catch(error => console.log(error));
    handleCloseObservacao();
  }

  const deletarSolicitacao = (id) => {
    let confirmacao = window.confirm("Você deseja realmente excluir a solicitação?");
    if (confirmacao === true) {
      setDeletado(false)
      servicosSolicitacao.deletar(id).then(response => {
        if (response.status === 200) {
          setDeletado(true);
          toast.success("A solicitação foi excluída com sucesso!", {
            theme: "colored",
          });
        }
      }).catch(error => {
        console.log(error);
        toast.error("Não foi possível excluir a solicitação!", {
          theme: "colored",
        });
      })
    }
  }


  const handleShow = (solicitacao) => {
    setSolicitacao(solicitacao);
    setShow(true);
  }

  const handleShowObservacao = (solicitacao) => {
    setSolicitacao(solicitacao);
    setShowObservacao(true);
  }


  const entregaMultiplas = async () => {
    if (itemsSelecionados.length > 0) {
      let confirmacao = window.confirm("Você deseja realmente entregar os produtos solicitados?");
      if (confirmacao === true) {
        setEditado(false);


        for await (const i of itemsSelecionados) {
          const entregas = {
            "status": "finalizado",
            "data_entrega": new Date(),
            "responsavel": user.nome
          }
          servicosSolicitacao.editar(i, entregas)
            .then(response => {
              if (response.status === 200) {
                setEntregue(i);
              }
            })
            .catch(e => {
              console.log(e);
            })
        }
        toast.success("As solicitações foram entregues!", {
          theme: "colored",
        });
      }

    }

  }

  const columnsSolicitacoesPendentes = [
    { field: "id_solicitacao", headerName: "ID", width: 45 },
    {
      field: "Colaborador[0].nome",
      headerName: "Solicitante",
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params.row.Colaborador[0].nome
      }
    },
    {
      field: "Produto[0].nome",
      headerName: "Produto",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        return params.row.Produto[0].nome
      }
    },
    {
      field: "Produto[0].tamanho",
      headerName: "Tamanho",
      width: 80,
      editable: false,
      valueGetter: (params) => {
        return params.row.Produto[0].tamanho
      }
    },
    {
      field: "milhas_solicitacao",
      headerName: "Milhas",
      width: 80,
      editable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      editable: true,
    },
    {
      field: "observacao",
      headerName: "Observação",
      width: 100,
      editable: true,
    },
    {
      field: "data_solicitacao",
      headerName: "Data Solicitação",
      width: 150,
      editable: false,
      valueGetter: (params) => {
        let aux = String(params.value).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    },
    {
      field: "editar",
      headerName: "Edit. Observação",
      width: 90,
      renderCell: (params) => {
        return <button size="sm" className="btn-icones p-1 rounded d-flex justify-content-center align-items-center" onClick={() => handleShowObservacao(params.row)}><Edit /> Editar</button>
      }
    },
    {
      field: "cancelar",
      headerName: "Cancelar",
      width: 90,
      renderCell: (params) => {
        return <button size="sm" className="btn-icones p-1 rounded d-flex justify-content-center align-items-center" onClick={(e) => handleShow(params.row)}><Cancel /> Cancelar</button>
      }
    },
    {
      field: "excluir",
      headerName: "Excluir",
      width: 90,
      renderCell: (params) => {
        if (autorizado === true) {
          return <button className="btn-icones p-1 rounded" value={params.row.id_solicitacao} onClick={() => deletarSolicitacao(params.row.id_solicitacao)}><Delete /> Excluir</button>
        } else {
          return ""
        }
      }
    }
  ];


  const ModalEditar = () => {
    return <>
      <Modal className="" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  Você deseja realmente cancelar essa solicitação? <br />
                  <br></br>
                  Produto: <strong>{solicitacao?.Produto[0].nome}</strong> <br />
                  O colaborador receberá de volta M$: <strong>{solicitacao?.Produto[0].milhas} </strong> <br />
                  {motivoVazio && <span className="errosValidacao">Por favor, nos informe o motivo do cancelamento.</span>}
                  <span>Motivo do cancelamento:</span>
                  <textarea ref={motivo_cancelamento} className="h-25" id="motivo_cancelamento">
                  </textarea>
                  <div className="text-center mt-4">
                    <button className="btn-icones p-1 rounded w-25 me-2" onClick={() => cancelarSolicitacao(motivo_cancelamento?.current?.value)} >
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones p-1 rounded w-25" variant="secondary" onClick={handleClose}>
                      <Cancel /> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }

  const ModalObservacao = () => {
    return <>
      <Modal className="" show={showObservacao} onHide={handleCloseObservacao}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  Adicionar observação:
                  <textarea ref={observacao} defaultValue={solicitacao?.observacao} className="h-25" id="observacao">
                  </textarea>
                  <div className="text-center mt-4">
                    <button className="btn-icones p-1 rounded w-25 me-2" onClick={() => editarSolicitacao()} >
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones p-1 rounded w-25" variant="secondary" onClick={handleCloseObservacao}>
                      <Cancel /> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }


  return (
    <>
      <NavMenu />
      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
          <ModalObservacao />
          <h3 className="text-start subtitulo" style={{ fontSize: 20 }}>Solicitações Pendentes</h3>

          <Box sx={{ height: 650, width: 950, marginTop: 2 }}>
            <DataGrid
              checkboxSelection
              style={{ borderRadius: "20px" }}
              localeText={localizedTextsMap}
              rows={solicitacoes}
              columns={columnsSolicitacoesPendentes}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              getRowId={(row) => row.id_solicitacao}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
              onSelectionModelChange={itemsSelecionados => {
                setItemsSelecionados(itemsSelecionados);
              }}

            />
          </Box>



          <button className="p-1 ms-1 mt-3 btn-esqueceu-senha  rounded border-1 text-light" onClick={entregaMultiplas}>Entregar produtos selecionados</button>
        </div>
      </div>
    </>
  );
};

export default ListSolicitacoesPendentes;